import { render, staticRenderFns } from "./experimentstatistics.vue?vue&type=template&id=b34568c4&"
import script from "./experimentstatistics.vue?vue&type=script&lang=js&"
export * from "./experimentstatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports